'use client';
const truncateNamePart = (namePart) => {
    const firstLetter = namePart[0];
    return firstLetter ? `${firstLetter}.` : '';
};
/**
 * Format a user's name
 * @param user
 * @param user.firstName - The user's first name
 * @param user.lastName - The user's last name
 * @param user.shouldTruncateLastName - Whether to truncate the last name [default: true]
 * @returns The formatted name
 */
const formatName = ({ firstName, lastName, shouldTruncateLastName = true, }) => {
    const formattedLastName = shouldTruncateLastName
        ? truncateNamePart(lastName)
        : lastName;
    return `${firstName} ${formattedLastName}`.trim();
};

export { formatName };
//# sourceMappingURL=format-name.js.map
